import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.every";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.some";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.match";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.for-each";
import _typeof from "/data/devops/workspace/node_modules/@babel/runtime/helpers/esm/typeof";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { validateRuleData } from '@/decorators';
import SurveyPivotalInput from './components/pivotalInput.vue';
import SurveyRadio from './components/radio.vue';
import SurveyCheckbox from './components/checkbox.vue';
import SurveySelect from './components/select.vue';
import SurveySingleCompletion from './components/singleCompletion.vue';
import SurveyMoreCompletion from './components/moreCompletion.vue';
import SurveyMatrixRadio from './components/matrixRadio.vue';
import SurveyMatrixCheckbox from './components/matrixCheckbox.vue';
import SurveyScale from './components/scale.vue';
import SurveyEvaluation from './components/evaluation.vue';
import SurveyMatrixScale from './components/matrixScale.vue';
import SurveyNpsScale from './components/npsScale.vue';

var IndexPage = function (_super) {
  __extends(IndexPage, _super);

  function IndexPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.surveyDetails = _this.initDetails();
    _this.questionList = [];
    _this.dependentList = [];
    _this.answerType = {
      stringAnswer: [_this.$enum.survey.QuestionTypeEnum.PIVOTAL_INPUT, _this.$enum.survey.QuestionTypeEnum.RADIO, _this.$enum.survey.QuestionTypeEnum.SELECT, _this.$enum.survey.QuestionTypeEnum.SINGLE_COMPLETION, _this.$enum.survey.QuestionTypeEnum.SCALE, _this.$enum.survey.QuestionTypeEnum.NPS_SCALE, _this.$enum.survey.QuestionTypeEnum.EVALUATION],
      stringArrAnswer: [_this.$enum.survey.QuestionTypeEnum.CHECKBOX],
      objectArrAnswer: [_this.$enum.survey.QuestionTypeEnum.MATRIX_RADIO, _this.$enum.survey.QuestionTypeEnum.MATRIX_SCALE, _this.$enum.survey.QuestionTypeEnum.MORE_COMPLETION],
      objectStringArrAnswer: [_this.$enum.survey.QuestionTypeEnum.MATRIX_CHECKBOX]
    };
    _this.conditionType = {
      AND: 1,
      OR: 0
    };
    _this.surveyId = undefined;
    _this.advise = '';
    _this.formDataRules = {};
    _this.showAdvisErrorMessage = false;
    return _this;
  }

  IndexPage.prototype.getAddRuleData = function (data) {
    this.formDataRules = this.$util.mergeValidate(data, {});
  };

  Object.defineProperty(IndexPage.prototype, "showQuestionList", {
    get: function get() {
      var _this = this;

      return this.questionList.filter(function (question) {
        return _this.showQuestionByDependent(question.question_id);
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(IndexPage.prototype, "adviseIsRequire", {
    get: function get() {
      var _this = this;

      var res1 = this.showQuestionList.some(function (question) {
        var _a, _b;

        if (question.type !== _this.$enum.survey.QuestionTypeEnum.EVALUATION) {
          return false;
        }

        var standardRate = question.options && ((_a = question.options[5]) === null || _a === void 0 ? void 0 : _a.value) || '';
        var answerRate = (_b = question.options.find(function (option) {
          return option.option_id === question.answer;
        })) === null || _b === void 0 ? void 0 : _b.value;
        return Number(answerRate) <= Number(standardRate) || !question.answer;
      });
      return res1;
    },
    enumerable: false,
    configurable: true
  });

  IndexPage.prototype.created = function () {
    this.surveyId = Number(this.$route.query.id);
  };

  IndexPage.prototype.handleSurveyDetailsChange = function () {
    this.getQuestionList();
  };

  IndexPage.prototype.showQuestionByDependent = function (questionId) {
    var _this = this;

    var dependents = this.dependentList.find(function (item) {
      return questionId === item.question_id;
    });

    if (!dependents) {
      return true;
    }

    var aswerRes = [];
    dependents.dependent_arr.forEach(function (dependent) {
      var _a;

      var question = _this.questionList.find(function (item) {
        return dependent.dependent_id === item.question_id;
      });

      if (!question) {
        aswerRes.push(true);
        return;
      }

      var answerArr = [];

      if (_this.answerType.stringAnswer.includes(question.type)) {
        var answerValue = (_a = question.options.find(function (option) {
          return option.option_id === question.answer;
        })) === null || _a === void 0 ? void 0 : _a.value;

        if (answerValue) {
          answerArr = [answerValue];
        }
      }

      if (_this.answerType.stringArrAnswer.includes(question.type)) {
        question.answer.forEach(function (item) {
          var _a;

          var answerValue = (_a = question.options.find(function (option) {
            return option.option_id === item;
          })) === null || _a === void 0 ? void 0 : _a.value;

          if (answerValue) {
            answerArr.push(answerValue);
          }
        });
      }

      var isMath = dependent.condition_value.some(function (item) {
        return answerArr.includes(item);
      });
      aswerRes.push(isMath);
    });
    var regRes = false;

    if (dependents.condition_type === this.conditionType.AND) {
      regRes = !aswerRes.includes(false);
    }

    if (dependents.condition_type === this.conditionType.OR) {
      regRes = aswerRes.includes(true);
    }

    if (!regRes) {
      var question = this.questionList.find(function (item) {
        return questionId === item.question_id;
      });
      this.initAnswer(question);
    }

    return regRes;
  };

  IndexPage.prototype.initDetails = function () {
    return {
      id: undefined,
      title: '',
      welcome_text: '',
      question_list: [],
      dependent_list: []
    };
  };

  IndexPage.prototype.getQuestionList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, question_list, dependent_list;

      return __generator(this, function (_b) {
        this.surveyDetails = JSON.parse(JSON.stringify(this.detailsData));
        _a = this.surveyDetails, question_list = _a.question_list, dependent_list = _a.dependent_list;
        this.questionList = question_list;
        this.dependentList = dependent_list;
        this.advise = '';
        this.setQuestionList();
        return [2];
      });
    });
  };

  IndexPage.prototype.setQuestionList = function () {
    var _this = this;

    this.questionList.forEach(function (question) {
      _this.$set(question, 'match', true);

      _this.$set(question, 'errorMsg', '');

      _this.$set(question, 'is_no_contact', _this.$enum.common.BoolIntEnum.NO);

      _this.initAnswer(question);
    });
  };

  IndexPage.prototype.initAnswer = function (question) {
    if (this.answerType.stringAnswer.includes(question.type)) {
      this.$set(question, 'answer', undefined);
    }

    if (this.answerType.stringArrAnswer.includes(question.type)) {
      this.$set(question, 'answer', []);
    }

    if (this.answerType.objectArrAnswer.includes(question.type)) {
      var answerList_1 = [];
      question.children.forEach(function (item) {
        var answer = {
          question_id: item.question_id,
          option_id: undefined
        };
        answerList_1.push(answer);
      });
      this.$set(question, 'answer', answerList_1);
    }

    if (this.answerType.objectStringArrAnswer.includes(question.type)) {
      var answerList_2 = [];
      question.children.forEach(function (item) {
        var answer = {
          question_id: item.question_id,
          option_id_list: []
        };
        answerList_2.push(answer);
      });
      this.$set(question, 'answer', answerList_2);
    }
  };

  IndexPage.prototype.handleClickNoContact = function (question) {
    question.mandatory = false;
    question.is_no_contact = this.$enum.common.BoolIntEnum.YES;
    question.match = this.validateAnswer(question);
  };

  IndexPage.prototype.handleInput = function (question) {
    question.match = this.validateAnswer(question);
  };

  IndexPage.prototype.validateAnswer = function (question) {
    var _this = this;

    if (!question.mandatory && !question.validate_rule) {
      return true;
    }

    if (this.answerType.stringAnswer.includes(question.type)) {
      if (typeof question.answer === 'string') {
        question.answer = question.answer.trim();
      }

      if (!question.answer) {
        question.match = false;
      } else {
        question.match = true;
      }
    }

    if (this.answerType.stringArrAnswer.includes(question.type)) {
      if (!question.answer.length) {
        question.match = false;
      } else {
        question.match = true;
      }
    }

    if (this.answerType.objectArrAnswer.includes(question.type)) {
      if (!question.answer.length) {
        question.match = false;
      } else {
        question.match = question.answer.every(function (answer) {
          if (typeof answer.option_id === 'string') {
            answer.option_id = answer.option_id.trim();
          }

          return !!answer.option_id;
        });
      }
    }

    if (this.answerType.objectStringArrAnswer.includes(question.type)) {
      if (!question.answer.length) {
        question.match = false;
      } else {
        question.match = question.answer.every(function (answer) {
          return answer.option_id_list.length;
        });
      }
    }

    if (question.type === this.$enum.survey.QuestionTypeEnum.PIVOTAL_INPUT) {
      if (question.match && question.validate_rule) {
        var rules_1 = question.validate_rule.split(',').map(function (rule) {
          return _this.formDataRules[rule] || [];
        });
        question.match = rules_1.some(function (ruleList) {
          return ruleList.every(function (rule) {
            var _a;

            question.errorMsg = rules_1.length > 1 ? _this.t('请完整回答此题') : rule.message || '';
            return (_a = rule.pattern) === null || _a === void 0 ? void 0 : _a.test(question.answer);
          });
        });
      }
    }

    return question.match;
  };

  IndexPage.prototype.validateAnswers = function () {
    var _this = this;

    var noMatchCount = 0;
    this.showQuestionList.forEach(function (item) {
      var res = _this.validateAnswer(item);

      if (!res) {
        noMatchCount++;
      }
    });

    if (noMatchCount > 0) {
      return false;
    }

    return true;
  };

  IndexPage.prototype.handleSubmit = function () {
    return __awaiter(this, void 0, Promise, function () {
      var validateRes, answerList, params;
      return __generator(this, function (_a) {
        validateRes = this.validateAnswers();

        if (!validateRes) {
          return [2];
        }

        if (this.adviseIsRequire && !this.advise) {
          this.showAdvisErrorMessage = true;
          return [2];
        }

        answerList = this.showQuestionList.map(function (question) {
          var question_id = question.question_id,
              type = question.type,
              answer = question.answer,
              is_no_contact = question.is_no_contact,
              validate_rule = question.validate_rule;
          var strAnswer;

          if (_typeof(answer) === 'object') {
            strAnswer = JSON.stringify(answer);
          } else {
            if (answer === undefined || answer === null) {
              strAnswer = '';
            } else {
              strAnswer = String(answer);
            }
          }

          return {
            question_id: question_id,
            type: type,
            answer: strAnswer,
            is_no_contact: is_no_contact,
            validate_rule: validate_rule
          };
        });
        params = {
          survey_id: this.surveyId,
          advise: this.advise,
          answer_list: answerList
        };
        this.$emit('submit', params);
        return [2];
      });
    });
  };

  IndexPage.prototype.handleClose = function () {
    window.close();
  };

  __decorate([Prop({
    type: Object
  })], IndexPage.prototype, "detailsData", void 0);

  __decorate([Prop({
    type: Boolean
  })], IndexPage.prototype, "loading", void 0);

  __decorate([Prop({
    type: Boolean
  })], IndexPage.prototype, "submitLoading", void 0);

  __decorate([Prop({
    type: Boolean,
    "default": false
  })], IndexPage.prototype, "isSuccessLoad", void 0);

  __decorate([Prop({
    type: Boolean,
    "default": false
  })], IndexPage.prototype, "isFinished", void 0);

  __decorate([Prop({
    type: Boolean,
    "default": false
  })], IndexPage.prototype, "isPreview", void 0);

  __decorate([validateRuleData('/api/v1/survey/submit')], IndexPage.prototype, "getAddRuleData", null);

  __decorate([Watch('detailsData', {
    deep: true,
    immediate: true
  })], IndexPage.prototype, "handleSurveyDetailsChange", null);

  IndexPage = __decorate([Component({
    components: {
      SurveyPivotalInput: SurveyPivotalInput,
      SurveyRadio: SurveyRadio,
      SurveyCheckbox: SurveyCheckbox,
      SurveySelect: SurveySelect,
      SurveySingleCompletion: SurveySingleCompletion,
      SurveyMoreCompletion: SurveyMoreCompletion,
      SurveyMatrixRadio: SurveyMatrixRadio,
      SurveyMatrixCheckbox: SurveyMatrixCheckbox,
      SurveyScale: SurveyScale,
      SurveyEvaluation: SurveyEvaluation,
      SurveyMatrixScale: SurveyMatrixScale,
      SurveyNpsScale: SurveyNpsScale
    }
  })], IndexPage);
  return IndexPage;
}(Vue);

export default IndexPage;